//import { useUserStore } from '@gik/core/store/UserStore';
import type { Group } from '@gik/core/models/gik/Group';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Grid } from '@gik/ui/Grid';
import { Separator } from '@gik/ui/Separator';
import React from 'react';
import { InkindGroupWidgetTile } from './InkindGroupWidgetTile';

export type InkindGroupWidgetGridProps = {
  showAllPages?: boolean;
  search?: string;
  group: Group;
  setSeeMoreButtonVisible?(visible: boolean): void;
  setNumResults?(total: number): void;
} & UIComponent;

export function InkindGroupWidgetGrid({ className, group }: InkindGroupWidgetGridProps) {
  const bem = useBemCN('inkind-group-widget-grid');

  const items = group?.inkindGroupSettings.inkindPageWidget?.links;
  // if (items?.length === 0) return <InkindGroupEmptyView group={group} search={search} />;

  return (
    <Grid {...bem(null, null, className)}>
      {items?.map((item, i) => {
        return (
          <React.Fragment key={item.url + ':' + i}>
            <a href={item.url} rel="noreferrer" target="_blank">
              <InkindGroupWidgetTile
                inkindPage={{
                  imgSrc: item.imageUrl,
                  title: item.label,
                }}
              />
            </a>
            {i < items?.length - 1 && <Separator size="sm" />}
          </React.Fragment>
        );
      })}
    </Grid>
  );
}
